
import {getGroups} from '../api/getGroups';
import {setGetGroupsAction} from '../action';

const setGetGroups = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getGroups(params);
    
            if (data.status === 'success') {
                dispatch(setGetGroupsAction(data.groups));
            }
          
            
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetGroups
}